import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import './HeaderMenu.css';

function HeaderMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => setOpen(!open);

  return (
    <div className="header-container">
      <FaBars className="menu-icon" onClick={toggleMenu} />

      <div className={`dropdown ${open ? 'open' : ''}`}>
        <button onClick={() => navigate('/create-job-card')}>Create Job Card</button>
        <button onClick={() => navigate('/view-job-cards')}>View All Job Cards</button>
        <button onClick={() => navigate('/track-status')}>Job Card Tracking</button>
        <button onClick={() => navigate('/dashboard')}>Dashboard</button>
      </div>
    </div>
  );
}

export default HeaderMenu;
